import { SET_SELECTED_TABLE_ROW } from 'store/actions/actionTypes';

export const setSelectedTableRow = (selectedRow: number) => ({
  type: SET_SELECTED_TABLE_ROW,
  payload: selectedRow,
});

export default undefined;